module.exports = __webpack_public_path__ + "static/media/tenant_planete-oui_in.4d5501ee.svg";